import { DocumentEntityTypesEnum, DocumentService, DocumentTypesEnum, RentPayTypesEnum } from "@propertelligent/client-api";
import { GetImages } from "../../../utils/GetImages";
import { useCallback, useEffect, useState } from "react";
import DateHelper from "../../../utils/DateHelper";
import UtilHelper from "../../../utils/UtilHelper";
import CurrencyTooltip from "../../currencytooltip/CurrencyTooltip";

const DocumentDownloadCard = ({ doc, onDownload }) => (
  <div
    className="d-flex gap-2 align-items-center borderWithRadius p-2 clickable"
    onClick={() => onDownload(doc?.id, doc?.fileName)}
  >
    <div className="d-flex align-items-center gap-2">
      <img src={GetImages.pdfImage} alt="" />
      <p className="sub_text blue">
        {doc?.fileName?.length > 10 ? `${doc?.fileName.substring(0, 10)}...` : doc?.fileName}
      </p>
    </div>
    <div className="clickable">
      <img src={GetImages.blueDownloadIcon} className="iconstyle16 color-white-icon" alt="Download" />
    </div>
  </div>
);

export const RentPayInfo = ({ data, leaseApplication, id, downloadDocument, tenantId }) => {
  const [documents, setDocuments] = useState([]);
  const {
    rentPayTypeId,
    employerDetails,
    assistedDetails,
    employmentIncome,
    assistedAmount,
  } = data || {};

  const getDocuments = useCallback((docType) => {
    if (!tenantId) return Promise.resolve([]);
    return DocumentService.getApiDocumentList(Number(tenantId), DocumentEntityTypesEnum.Tenant, docType)
      .then((res) => {
        const documentArray = res?.success;
        if (!documentArray) return [];
        const promises = documentArray.map((item) => {
          if (["png", "jpg", "jpeg"].includes(item?.fileName?.split(".")[1]?.toLowerCase())) {
            return DocumentService.getApiDocumentBase641(item.id)
              .then((res) => { item["docData"] = "data:image/png;base64," + res.success; })
              .catch(() => {});
          }
          return Promise.resolve();
        });
        return Promise.all(promises).then(() => documentArray);
      })
      .catch(() => []);
  }, [tenantId]);

  useEffect(() => {
    let cancelled = false;
    if (rentPayTypeId === RentPayTypesEnum.Income) {
      getDocuments(DocumentTypesEnum.IncomeVerification).then((arr) => {
        if (!cancelled) setDocuments(arr || []);
      });
    } else if (rentPayTypeId === RentPayTypesEnum.Assisted) {
      getDocuments(DocumentTypesEnum.AssistanceVerification).then((arr) => {
        if (!cancelled) setDocuments(arr || []);
      });
    } else if (rentPayTypeId === RentPayTypesEnum.Both) {
      Promise.all([
        getDocuments(DocumentTypesEnum.IncomeVerification),
        getDocuments(DocumentTypesEnum.AssistanceVerification),
      ]).then(([incomeDocs, assistedDocs]) => {
        if (!cancelled) setDocuments([...(incomeDocs || []), ...(assistedDocs || [])]);
      });
    }
    return () => { cancelled = true; };
  }, [rentPayTypeId, tenantId, getDocuments]);

  const incomeDocs = documents.filter(
    (doc) =>
      rentPayTypeId === RentPayTypesEnum.Income ||
      (rentPayTypeId === RentPayTypesEnum.Both && doc?.documentTypeId === DocumentTypesEnum.IncomeVerification)
  );
  const assistedDocs = documents.filter(
    (doc) =>
      rentPayTypeId === RentPayTypesEnum.Assisted ||
      (rentPayTypeId === RentPayTypesEnum.Both && doc?.documentTypeId === DocumentTypesEnum.AssistanceVerification)
  );

  const renderDocumentList = (docs, onDownload) =>
    docs.length > 0 ? (
      <div className="FlexRow px-3 py-2">
        <div className="fileDeleteSection rent-doc-list rent-doc-list--wrap">
          {docs.map((doc, index) => (
            <DocumentDownloadCard key={doc?.id ?? index} doc={doc} onDownload={onDownload} />
          ))}
        </div>
      </div>
    ) : null;

  return (
    
    <>
      {(rentPayTypeId === RentPayTypesEnum.Income || rentPayTypeId === RentPayTypesEnum.Both) ? (
        <div className="px-3">
        <div className="flexRow justify-content-between rentpay_information ">
          <div className="rentpay_information-left flexRow gap-3">
            <div className="rentpay-avatar"> <div className="tenant-initials">{UtilHelper.getInitials(employerDetails?.firstName + " " + employerDetails?.lastName)}</div> </div>
            <div className="flexColumn gap-2">
            <p className="heading black">{employerDetails.name}
              <span className="sub_text green BackgroundlightGreen p-1 mx-2 rounded text-center "> Income </span>
            </p>
                    <p className="listing-type">
                       Employer: {employerDetails?.firstName} {employerDetails?.lastName} • {employerDetails?.email} • {UtilHelper.formatPhoneForDisplay(employerDetails?.phoneNumber)}
                      </p>
                      </div>
          </div>
          <div className="flexRowCenter gap-2">
            <div className="p-2 flexColumnCenter ">
              <CurrencyTooltip
                content={employmentIncome}
                formatted={employmentIncome}
              >
                <p className="normal_text fw-700 black">{UtilHelper.CurrencyFormat(Number(employmentIncome), false)}</p>
              </CurrencyTooltip>
              <p className="normal_text ">Income/Month</p>
            </div>
            
            <div className="p-2 flexColumnCenter BorderLeft">
              <p className="normal_text fw-700 black">{DateHelper.convertUTCtoDateTimeSimple(employerDetails.startDate)}</p>
              <p className="normal_text ">Employment Since</p>
            </div>
          </div>
         
        </div>
        {renderDocumentList(incomeDocs, downloadDocument)}
        {rentPayTypeId === RentPayTypesEnum.Both ? <div className="separator-horizontal" /> : null}
         </div>
      ) : null}
      
        
      {rentPayTypeId === RentPayTypesEnum.Assisted || rentPayTypeId === RentPayTypesEnum.Both ? (
        <div className="px-3">
        <div className="d-flex justify-content-between rentpay_information ">
          <div className="rentpay_information-left flexRow gap-3">
            <div className="rentpay-avatar"> <div className="tenant-initials">{UtilHelper.getInitials(assistedDetails?.firstName + " " + assistedDetails?.lastName)}</div> </div>
            <div className="flexColumn gap-2">
            <p className="heading black">{assistedDetails.name}
              <span className="sub_text green BackgroundlightGreen p-1 mx-2 rounded text-center "> Assisted </span>
            </p>
                    <p className="listing-type">
                       Social Worker: {assistedDetails?.firstName} {assistedDetails?.lastName} • {assistedDetails?.email} • {UtilHelper.formatPhoneForDisplay(assistedDetails?.phoneNumber)}
                      </p>
                      </div>
          </div>
          <div className="p-2 flexColumnCenter ">
              <CurrencyTooltip
                content={assistedAmount}
                formatted={assistedAmount}
              >
                <p className="normal_text fw-700 black">{UtilHelper.CurrencyFormat(Number(assistedAmount), false)}</p>
            </CurrencyTooltip>
            <p className="normal_text">Amount/Month</p>
          </div>
        </div>
        {renderDocumentList(assistedDocs, downloadDocument)}
        </div>
      ) : null}
    </>
  );
};